import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KngButtonModule, KngFooterModule, KngLoaderModule } from 'kinetic-angular';
import { AnalyticsModule } from '../../services/analytics/analytics.module';
import { ContactUsComponent } from './contact-us.component';
import { ContactUsService } from './contact-us.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
	declarations: [ContactUsComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		KngLoaderModule,
		AnalyticsModule,
		BrowserModule,
		ReactiveFormsModule,
		KngButtonModule,
		KngFooterModule,
		MatSelectModule
	],
	exports: [ContactUsComponent],
	providers: [ContactUsService]
})
export class ContactUsModule {}
